import Text from 'atoms/Text';
import { DropdownStyles } from 'helper/styles';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import CustomMultiSelect from './CustomMultiSelect';

const AsyncReactSelectPaginate = ({
    id,
    name,
    placeholder,
    options,
    isRequired,
    label,
    isError,
    errorMessage,
    register = () => { },
    control,
    errors,
    required,
    size,
    loadOptions = () => { },
    isMulti,
    menuPlacement = 'auto',
    menuPosition = 'fixed',
    isClearable = true,
    title = '',
    isNotes = false,
    note = '',
    textColor = '',
    readOnly = false,
    color = '#53565A',
    maxHeight = '300px',
    searchTextxx,
    onInputChange,
    ...rest
}) => {

    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const components = isMulti ? { Option: CustomMultiSelect } : {};

    return (
        <div className={`${rest?.className}`}>
            {title && (
                <Text variant='bodySemibold' className='mb-4 text-base'>{title}</Text>)}
            {label && (
                <label className={'text-[12px] text-gray-1100 mb-1 block leading-4 '}>
                    {label}
                    {isRequired && <span className="text-red-700 ml-1">*</span>}
                </label>
            )}

            <div className={`${rest?.inputClassName}`}>
                {
                    control ? (
                        <Controller
                            control={control}
                            name={name}
                            rules={{
                                required
                            }}
                            render={({ field }) => (
                                <AsyncPaginate
                                    id={id}
                                    name={name}
                                    debounceTimeout={300}
                                    defaultOptions={options}
                                    placeholder={placeholder}
                                    styles={DropdownStyles(isError, size, textColor, readOnly, color, maxHeight)}
                                    loadOptions={(inputValue) => loadOptions(inputValue, setOffset, setHasMore)}
                                    components={components}
                                    isMulti={isMulti}
                                    menuPosition={menuPosition}
                                    menuPlacement={menuPlacement}
                                    menuShouldScrollIntoView={false}
                                    isClearable={isClearable}
                                    className={isMulti ? 'multiSelectScroll' : ''}
                                    {...field}
                                    {...rest}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        if (rest.onChange) {
                                            rest.onChange(e);
                                        }
                                    }}
                                    inputValue={rest.searchText}
                                    onInputChange={(value) => {
                                        if (rest.onInputChangezz) rest.onInputChangezz(value);
                                        setOffset(0);
                                        setHasMore(true);
                                        return value;
                                    }}
                                />
                            )}
                        />
                    ) : (
                        <AsyncPaginate
                            {...register(name)}
                            id={id}
                            name={name}
                            defaultOptions={options}
                            placeholder={placeholder}
                            styles={DropdownStyles(isError, size, textColor, readOnly, color, maxHeight)}
                            loadOptions={loadOptions}
                            components={components}
                            isMulti={isMulti}
                            menuPosition={menuPosition}
                            menuPlacement={menuPlacement}
                            menuShouldScrollIntoView={false}
                            isClearable={isClearable}
                            {...rest}
                        />
                    )
                }

            </div>
            {isError && <div className="text-red-900 text-[12px] pt-1 error-in-field">{errorMessage}</div>}
            {isNotes && <div className="text-gray-900 text-xs mt-1">{note}</div>}
        </div>
    );
};

export default AsyncReactSelectPaginate;
